import PropTypes from "prop-types";
import { useEffect } from "react";
import clsx from "clsx";

// MUI
import { Popper } from "@mui/material";

export function CustomPopper(props) {
	const { setPopperPlacement = () => {}, additionalClass = "", ...properties } = props;

	useEffect(() => {
		const node = document.getElementById("advanced-select-popper");
		if (node) {
			const placement = node.getAttribute("data-popper-placement");
			setPopperPlacement(placement);
		}
		return () => {
			setPopperPlacement("default");
		};
	});

	return (
		<Popper
			id={"advanced-select-popper"}
			{...properties}
			className={clsx({
				"MuiAutocomplete-popper z-[1300] border border-solid border-disabled advanced-select-popper": true,
				[additionalClass]: Boolean(additionalClass),
			})}
			placement="bottom"
		/>
	);
}

CustomPopper.propTypes = {
	setPopperPlacement: PropTypes.func,
	additionalClass: PropTypes.string,
};
